// Development : if you have update cache issues, add ?v=1 to the end of the import and change the version for each edit
import BrandReviews from "./BrandReviews.js";
document.addEventListener('DOMContentLoaded', event => {
  let reviews = new BrandReviews(document.querySelector('#brand-reviews'), parseInt(document.querySelector('#brand-reviews').getAttribute('data-reviews-number')));
  console.log('init reviews');
  reviews.init(() => {
    reviews.generateHtml();
  });
});